module.exports = __webpack_public_path__ + "img/gensis.4da405bb.png";